function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Skeleton = /*#__PURE__*/function () {
  function Skeleton(config) {
    _classCallCheck(this, Skeleton);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "containerEle", void 0);
    _defineProperty(this, "skeletonEle", void 0);
    _defineProperty(this, "styleEle", void 0);
    this.config = _objectSpread({}, config);
    var ele = config.ele;
    if (ele instanceof HTMLElement) {
      this.containerEle = ele;
    } else {
      this.containerEle = document.querySelector(ele);
    }
    if (!this.containerEle) {
      throw new Error('找不到挂载骨架屏的父元素');
    }
  }

  /** 创建骨架屏 */
  _createClass(Skeleton, [{
    key: "create",
    value: function create() {
      if (!this.containerEle) {
        return;
      }
      var skeletonEle = document.createElement('div');
      var styleEle = document.createElement('style');
      skeletonEle.classList.add('skeleton--animated');
      var linearGradient = ["90deg", "hsla(0, 0%, 74.5%, 0.2) 25%", "hsla(0, 0%, 50.6%, 0.24) 37%", "hsla(0, 0%, 74.5%, 0.2) 63%"].join(', ');
      var skeletonAnimated = "\n      @keyframes skeleton {\n        0% {\n          background-position: 100% 50%;\n        }\n        100% {\n          background-position: 0 50%;\n        }\n      }\n    ";
      styleEle.innerHTML = "\n      .skeleton--animated{\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(".concat(linearGradient, ");\n        background-size: 400% 100%;\n        animation: skeleton 2s linear infinite;\n      }\n      ").concat(skeletonAnimated, "\n    ");
      if (getComputedStyle(this.containerEle).position === 'static') {
        this.containerEle.style.position = 'relative';
      }
      Object.entries(this.config.style || {}).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          styleKey = _ref2[0],
          styleValue = _ref2[1];
        skeletonEle.style[styleKey] = styleValue;
      });
      this.containerEle.insertBefore(skeletonEle, this.containerEle.firstChild);
      this.containerEle.insertBefore(styleEle, this.containerEle.firstChild);
      this.skeletonEle = skeletonEle;
      this.styleEle = styleEle;
    }

    /** 移除已创建的骨架屏 */
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.containerEle) {
        return;
      }
      this.styleEle && this.containerEle.removeChild(this.styleEle);
      this.skeletonEle && this.containerEle.removeChild(this.skeletonEle);
    }
  }]);
  return Skeleton;
}();
export default Skeleton;